import classNames from "@lib/classNames";
import { SponsoredCarouselVariant } from "./sponsored-carousel";
import Image from "next/image";
import { Trans } from "@lingui/macro";
import Link from "next/link";

interface SponsoredCardProps {
  title: string;
  imageUrl: string;
  link: string;
  variant: string;
}

const SponsoredCard: React.FC<SponsoredCardProps> = ({
  title,
  imageUrl,
  link,
  variant,
}) => {
  const _card = () => {
    return (
      <div className="mt-2 w-[343px]">
        <div
          className={classNames(
            "relative h-full w-full overflow-hidden rounded-lg",
            variant === SponsoredCarouselVariant.landscape
              ? "aspect-[1.77]"
              : "aspect-1"
          )}
        >
          <Image
            src={imageUrl}
            alt={`${title}`}
            layout="fill"
            objectFit="cover"
          />
        </div>
        <p className="mt-2 font-poppins text-sm text-text-darkest transition-colors duration-300 group-hover:text-text-medium">
          {title}
        </p>
        <p className="mt-2 font-sen text-xs text-text-lightest">
          <Trans>Sponsored</Trans>
        </p>
      </div>
    );
  };

  return (
    <>
      <div className="mt-2 flex flex-col items-center">
        {link ? (
          <Link href={link} passHref>
            <a className="group" target="_blank" rel="noopener noreferrer">
              {_card()}
            </a>
          </Link>
        ) : (
          _card()
        )}
      </div>
    </>
  );
};

export default SponsoredCard;
